import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_highcharts = _resolveComponent("highcharts")!

  return (_ctx.showCharts)
    ? (_openBlock(), _createBlock(_component_highcharts, {
        key: 0,
        options: _ctx.options,
        class: "chart-container"
      }, null, 8, ["options"]))
    : _createCommentVNode("", true)
}